/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import ModalBox from '../../components/ModalBox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import DeleteIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { OverlaiedLoaderMsg } from '../../components/Loader';
import { Row, Input } from 'react-materialize';
import { ContainedLoader } from '../../components/Loader';
import CircularProgress from '@material-ui/core/CircularProgress';
import { formats, formatsText, formatsInputFile } from '../../utils/imagesAccept';
import { allNotifications } from '../../utils/toastify';
import { ToastContainer } from 'react-toastify';
import services from '../../services/services';
import PdfIcon from '../../image/pdf.svg';

const { notifyErrorBottomRight, notifySuccessBottomRight } = allNotifications;
const statusNaoCancelaveis = [3, 1006, 6, 1414, 24, 1811, 3011, 3048, 23]
let prontosParaFaturar = [];

class GtoDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: true,
      imagesPending: [],
      pdfLoading: false,
      gtoData: props.location.state,
      data: props.location.state.data,
      gtoId: 0,
      alertCard: false,
      alertCardProcedure: false,
      alertCreatedGto: false,
      alertGtoPending: false,
      procedures: [],
      selectedProcedure: {},
      infoProcedures: null,
      listaProceduresFaturadas: [],
      loadingStatus: true,
      observacoes: '',
      dataPagamento: '',
      btnDisabled: null,
      disabledCnlGTO: null,
      pendingCount: 0,
      inputFileKey: 0,
      isReloading: true,
      isLoadingFaturamento: false,
      regANS: null
    };
    prontosParaFaturar = [];
  }

  componentDidMount = async () => {
    if (!this.state.gtoData) {
      this.props.history.push({ pathname: '/home' });
    } else {
      const { gtoId } = this.state.gtoData;
      const { regANS } = this.state.gtoData;
      const codigoPrestador = this.props.codigo;

      await this.setState({ gtoId, regANS });

      const res = await services.mobileengine('buscarGtoProcedimentosDetalhes', { codigoPrestador, gtoId }).catch(err => {
        notifyErrorBottomRight(err);
        this.toggleCreate();
      });

      const infoProcedimento = await services
        .mobileengine('buscarInfoProcedimentos', { codigoPrestador, gtoId })
        .catch(err => {
          notifyErrorBottomRight(err);
          this.toggleCreate();
        })
        .finally(() => {
          this.setState({ loadingStatus: false, isReloading: false });
        });
      await this.setState({ procedures: res.gto_det_models.filter(p => !p.flag_recurso), infoProcedures: infoProcedimento });
      await this.setState({ disabledCnlGTO: this.allProceduresCanceled() });
      await this.setState({ listaProceduresFaturadas: JSON.parse(localStorage.getItem('listaProceduresFaturadas')) })

      this.setFlagProcedimentoExcluido();
    }
  };

  toggleCreate = () => {
    this.setState(prevState => ({
      modalActive: !prevState.modalActive
    }));
    this.props.history.goBack();
  };

  handlePdfLink = () => {
    const { gtoId } = this.state.gtoData;

    this.setState({ pdfLoading: true });

    services
      .procedimento('getPDFGTO', { gtoId })
      .then(res => {
        const byteCharacters = atob(res.data.pdfObject);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: 'application/pdf' });
        const pdfURL = URL.createObjectURL(file);

        window.open(pdfURL);
      })
      .catch(err => {
        notifyErrorBottomRight(err.message);
      })
      .finally(() => {
        this.setState({ pdfLoading: false });
      });
  };

  // TODO: Encapsular validação de imagens
  handleAddImage = async event => {
    // validates the image and add it to imagesPending state from wrapper
    if (this.state.imagesPending.length > 0) {
      this.setState({ imagesPending: [] });
    }
    await this.imageValidation(event); // devolve a imagesPending -> ver se eh um array ou uma imagem só
  };

  readFile = file =>
    new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });

  /*compress = file =>
    new Promise(resolve => {
      Resizer.imageFileResizer(file, 720, 1280, 'JPEG', 60, 0, uri => resolve(uri), 'blob');
    });*/

  imageValidation = async event => this.changeFileImage(event);

  changeFileImage = async event => {
    let files = event.target.files[0];
    //const maxImgSize = 150000;
    const securityMaxImgSize = 10000000;

    if (!files) return;

    if (files.size > securityMaxImgSize) {
      // this.setState({ error: true });
      notifyErrorBottomRight(`3166 - Arquivo enviado excede o tamanho máximo permitido (O arquivo deve ter no máximo 10 MB).`);
      return;
    }

    if (
      !formats.some(f =>
        files.name
          .split('.')
          .pop()
          .toLowerCase()
          .includes(f.toLowerCase())
      )
    ) {
      // filter by extension in file name
      // this.setState({ error: true });
      notifyErrorBottomRight(`As extensões válidas são ${formatsText}.`);
      return;
    }

    /*if (files.size > maxImgSize) {
      const { name, lastModifiedDate } = files;
      files = await this.compress(files);
      files.name = name;
      files.lastModifiedDate = lastModifiedDate;
    }*/

    const promises = await this.readFile(files).then(() => {
      const objectURL = window.URL.createObjectURL(files); // link virtual da imagem

      this.setState(previousState => ({
        imagesPending: [
          ...previousState.imagesPending,
          {
            name: files.name,
            src: objectURL,
            type: `.${files.type.split('/')[1]}`,
            file: files
          }
        ]
      }));
    });

    await Promise.resolve(promises);
  };

  getImageFileName = image => {
    if (!image) return '';

    if (image.nome_arquivo) return image.nome_arquivo;
    if (image.name) return image.name;

    if (image.url) {
      const sanitizedUrl = image.url.split('?')[0];
      const parts = sanitizedUrl.split('/');
      return decodeURIComponent(parts[parts.length - 1] || '');
    }

    return '';
  };

  getImageScope = image => {
    if (!image) return '';

    if (image.categoria && image.categoria !== 'OPCIONAL') {
      return image.categoria;
    }

    const fileName = this.getImageFileName(image);

    if (fileName.startsWith('FOTOINICIAL__')) return 'FOTOINICIAL';
    if (fileName.startsWith('FOTOFINAL__')) return 'FOTOFINAL';
    if (fileName.startsWith('OPCIONAL__')) return 'OPCIONAL';

    return image.categoria || 'OPCIONAL';
  };

  hasImageInScope = (images, scope) => images.some(image => this.getImageScope(image) === scope);

  verificarStatusProcedimento = procedure => {
    const { infoProcedures, listaProceduresFaturadas } = this.state;

    if (statusNaoCancelaveis.includes(procedure.cod_glosa_tiss)) {

      return <span className="status-badge excluido">Não Cancelado</span>;
    }

    if (procedure.flag_procedimento_excluido || procedure.status == 3049) {
      return <span className="status-badge excluido">Cancelado com sucesso</span>;
    }

    if (infoProcedures) {
      const infoProcedure = infoProcedures.procedimentos.find(
        proc => proc.id_procedimento === procedure.cod_interno
      );

      if (infoProcedure !== undefined && infoProcedure.data_realizacao === null) {
        if (listaProceduresFaturadas) {
          const procedimento = listaProceduresFaturadas.find(
            proc => proc.cod_interno === procedure.cod_interno
          )

          if (procedimento) {
            infoProcedure.data_realizacao = procedimento.selected_data_realizacao;
          }
        }
      }

      if (infoProcedure !== undefined && infoProcedure.data_realizacao !== null) {
        const images = infoProcedure.imagens || [];
        let isReady = true;

        if (
          (procedure.flag_rxinicial === true && images.length === 0) ||
          (procedure.flag_rxinicial === true && !images.some(x => x.categoria === 'RXINICIAL'))
        ) {
          isReady = false;
        }
        if (
          (procedure.flag_rxfinal === true && images.length === 0) ||
          (procedure.flag_rxfinal === true && !images.some(x => x.categoria === 'RXFINAL'))
        ) {
          isReady = false;
        }
        if (
          (procedure.flag_necessita_laudo === true && images.length === 0) ||
          (procedure.flag_necessita_laudo === true && !images.some(x => x.categoria === 'LAUDOTERMO'))
        ) {
          isReady = false;
        }
        if (
          (procedure.flg_foto_inicial === true && images.length === 0) ||
          (procedure.flg_foto_inicial === true && !this.hasImageInScope(images, 'FOTOINICIAL'))
        ) {
          isReady = false;
        }
        if (
          (procedure.flg_foto_final === true && images.length === 0) ||
          (procedure.flg_foto_final === true && !this.hasImageInScope(images, 'FOTOFINAL'))
        ) {
          isReady = false;
        }

        if (isReady) {
          if (!prontosParaFaturar.some(item => item.id_procedimento === infoProcedure.id_procedimento)) {
            const pronto = { ...procedure, ...infoProcedure };
            prontosParaFaturar.push(pronto);
          }

          return <span className="status-badge pronto">Pronto para faturar</span>;
        }
      }

      if (procedure.flag_pagamento_pre_faturamento === true) {
        return <span className="status-badge autorizado">Autorizado</span>;
      }
      return <span className="status-badge nao-autorizado">Não autorizado</span>;
    }
    if (procedure.flag_pagamento_pre_faturamento === true) {
      return <span className="status-badge autorizado">Autorizado</span>;
    }
    return <span className="status-badge nao-autorizado">Não autorizado</span>;
  };

  handleExcluirGto = procedure => {
    if (procedure) {
      this.setState({
        alertCardProcedure: !this.state.alertCardProcedure,
        selectedProcedure: procedure
      });
    } else {
      this.setState({ alertCard: !this.state.alertCard });
    }
  };

  handleOk = () => {
    const { gtoId } = this.state.gtoData;
    const codigoPrestador = this.props.codigo;
    const { selectedProcedure, alertCard, procedures } = this.state;

    let procedimentos = [];
    if (selectedProcedure.cod_proced) {
      const procedimento = {
        linha: selectedProcedure.linha,
        codigo_procedimento: selectedProcedure.cod_proced,
        dente_regiao: selectedProcedure.regiao,
        face: selectedProcedure.face
      };
      procedimentos = [...procedimentos, procedimento];
    }

    services
      .procedimento('cancelGTO', { gtoId, procedimentos })
      .then(() => {
        if (alertCard) {
          notifySuccessBottomRight('GTO cancelada com sucesso');
          this.setState({
            procedures: [
              ...procedures,
              procedures.map(proc => proc.flag_procedimento_excluido === true)
            ],
            alertCard: false
          });

          // Exclusão de todas as imagens da GTO e seus procedimentos
          procedures.forEach(function (p) {
            services
              .mobileengine('excluirDataRealizacao', {
                codigoPrestador,
                gtoId,
                idProcedimento: p.cod_interno
              })
              .catch(err => {
                notifyErrorBottomRight(err);
              })
          });
        } else {
          notifySuccessBottomRight('Procedimento cancelado com sucesso');
          const procedureUpdated = procedures.find(
            proc => proc.cod_interno === selectedProcedure.cod_interno
          );
          procedureUpdated.flag_procedimento_excluido = true;

          this.setState({
            procedures: procedures.map(proc =>
              proc.cod_interno === selectedProcedure.cod_interno ? procedureUpdated : proc
            ),
            alertCardProcedure: false
          });

          // Exclusão das imagens apenas do procedimento selecionado
          services
            .mobileengine('excluirDataRealizacao', {
              codigoPrestador,
              gtoId,
              idProcedimento: selectedProcedure.cod_interno
            })
            .catch(err => {
              notifyErrorBottomRight(err);
            });
        }
        this.componentDidMount();

      })
      .catch(() => {
        notifyErrorBottomRight('Não foi possível completar a ação. Tente novamente');
      });
  };

  handleFaturarProcedimento = async procedure => {
    const { infoProcedures, listaProceduresFaturadas } = this.state;

    if (infoProcedures) {
      const infoProcedure = infoProcedures.procedimentos.find(
        proc => String(proc.id_procedimento) === String(procedure.cod_interno)
      );
      if (infoProcedure) {
        const procedimento = listaProceduresFaturadas
          ? listaProceduresFaturadas.find(
            proc => String(proc.cod_interno) === String(procedure.cod_interno)
          )
          : null;
        const selectedDate = procedimento ? procedimento.selected_data_realizacao : undefined;
        const imagens = infoProcedure.imagens || [];

        this.props.history.push({
          pathname: '/faturar-procedimento',
          state: {
            procedure,
            listaProceduresFaturadas,
            selectedDate,
            imagens
          }
        });
      } else {
        this.props.history.push({
          pathname: '/faturar-procedimento',
          state: {
            procedure,
            listaProceduresFaturadas
          }
        });
      }
    } else {
      this.props.history.push({
        pathname: '/faturar-procedimento',
        state: {
          procedure,
          listaProceduresFaturadas
        }
      });
    }
  };

  countProceduresPending = () => {
    const { procedures } = this.state;
    let count = 0;

    procedures.forEach(proc => {
      if (
        !proc.flag_procedimento_excluido &&
        !prontosParaFaturar.some(pronto => pronto.cod_interno === proc.cod_interno)
      ) {
        count += 1;
      }
    });

    if (count === 0) {
      this.handleFaturar();
    } else {
      this.setState({ pendingCount: count, alertGtoPending: true });
    }
  };

  allProceduresCanceled = () => {
    const { procedures } = this.state;
    let count = 0;

    procedures.forEach(proc => {
      if (!proc.flag_procedimento_excluido && proc.status != 3049) {
        count += 1;
      }
    });

    if (count === 0) {
      return true;
    } else {
      return false;
    }
  };

  setFlagProcedimentoExcluido = () => {
    const { procedures } = this.state;

    procedures.forEach(procedure => {

      if (procedure.status == 3049) {

        procedure.flag_procedimento_excluido = true;

        this.setState({
          procedures: procedures.map(proc =>
            proc.cod_interno === procedure.cod_interno ? procedure : proc
          )
        });
      }
    });
  }

  handleFaturar = async () => {
    await this.setState({ btnDisabled: true, alertGtoPending: false, isLoadingFaturamento: true });

    const codigoPrestador = this.props.codigo;
    const { gtoId } = this.state.gtoData;
    const codigoBeneficiario = this.state.procedures[0].cod_benef;
    const procedimentos = [];
    const imageGto = this.state.imagesPending[0];

    prontosParaFaturar.forEach(pronto => {
      let contemImagem = pronto.imagens.length > 0;
      let dataRealizacao = new Date(pronto.data_realizacao);
      dataRealizacao.setDate(dataRealizacao.getDate() + 1);
      dataRealizacao = dataRealizacao.toLocaleDateString('pt-br');

      const procedimento = {
        data_realizacao: dataRealizacao,
        id_procedimento: pronto.cod_interno,
        contem_imagem: contemImagem,
        codigo_procedimento: pronto.cod_proced.trim(),
        dente_regiao: pronto.regiao !== '' ? pronto.regiao : '',
        face: pronto.face !== '' ? pronto.face : '',
        linha: pronto.linha
      };
      procedimentos.push(procedimento);
    });

    try {
      const url = await services.mobileengine('adicionarImagemGto', {
        codigoPrestador,
        gtoId,
        nomeArquivo: imageGto.name
      });
      await services.gcp('uploadImagemGcp', { url, file: imageGto.file });
    } catch (err) {
      await this.setState({ isLoadingFaturamento: false });
      notifyErrorBottomRight('Não foi possível faturar a GTO no momento, tente novamente.');
      return;
    }

    const faturarRequest = {
      codigoPrestador,
      codigoBeneficiario,
      gtoId,
      observacoes: this.state.observacoes,
      procedimentos
    };

    this.faturarGto(faturarRequest);
  };

  faturarGto = faturarRequest => {
    const {
      codigoPrestador,
      codigoBeneficiario,
      gtoId,
      observacoes,
      procedimentos
    } = faturarRequest;

    services
      .mobileengine('faturarGto', {
        codigoPrestador,
        codigoBeneficiario,
        gtoId,
        observacoes,
        procedimentos
      })
      .then(responseFaturar => {
        this.setState({
          dataPagamento: responseFaturar.data_pagamento,
          alertCreatedGto: !this.state.alertCreatedGto,
          isLoadingFaturamento: false,
          listaProceduresFaturadas: this.state.listaProceduresFaturadas.filter(item => item.orcamento !== gtoId)
        });

        localStorage.setItem('listaProceduresFaturadas', JSON.stringify(this.state.listaProceduresFaturadas));
      })
      .catch(() => {
        this.setState({ btnDisabled: null, isLoadingFaturamento: false });
        notifyErrorBottomRight('Não foi possível faturar a GTO no momento, tente novamente.');
      });
  };

  handleRemoveImgGTO = () => {
    this.setState({ imagesPending: [], inputFileKey: Date.now() });
  };

  handleObservacao = e => {
    const { value } = e.target;

    this.setState({ observacoes: value });
  };

  handleOkFaturar = () => {
    const { data } = this.state;

    this.props.history.push({
      pathname: '/solicitar-gto',
      state: { data, realizada: true }
    });
    this.setState({ alertCreatedGto: false });
  };

  validarFaturamento = () => {
    let contemErro = false;

    const { imagesPending } = this.state;

    if (imagesPending.length === 0 || prontosParaFaturar.length === 0) {
      contemErro = true;
    }

    return contemErro;
  };

  somarValorTotalProcedimentos = () => {
    let valorTotal = 0;
    const { procedures } = this.state;
    const { infoProcedures } = this.state;

    if (infoProcedures) {
      infoProcedures.procedimentos.forEach(procedure => {
        if (procedure.data_realizacao) {

          const selectProcedure = procedures.find(
            proc => proc.cod_interno === procedure.id_procedimento
          );

          valorTotal = valorTotal + selectProcedure.valor;
        }
      });
    }

    const formatter = new Intl.NumberFormat('pt-BR', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });

    return formatter.format(valorTotal);
  };

  render() {
    const {
      imagesPending,
      pdfLoading,
      alertCard,
      alertCardProcedure,
      alertCreatedGto,
      alertGtoPending,
      procedures,
      selectedProcedure,
      gtoId,
      loadingStatus,
      isLoadingFaturamento,
      pendingCount
    } = this.state;

    const btnDisable = this.validarFaturamento();


    return (
      <ModalBox
        modalActive={this.state.modalActive}
        modalLabel="Solicitadas"
        onChange={this.toggleCreate}
        style={{ padding: 15 }}
      >
        <ToastContainer />

        <div className="imprimir-gto noselect">
          É necessário imprimir a GTO para datar e solicitar a assinatura do paciente.
          {` `}
          {!pdfLoading ? (
            <span className="pdf-link" onClick={() => this.handlePdfLink()}>
              Clique aqui
            </span>
          ) : (
            <CircularProgress disableShrink style={{ width: 15, height: 15 }} />
          )}
          {` `}
          para imprimir.
        </div>
        <div className="row">
          <div className="col s8 number-gto">{`GTO ${gtoId}`}</div>
          <div
            className="col s4 excluir-gto"
            role="button"
            tabIndex={0}
            onClick={() => this.setState({ alertCard: !this.state.alertCard })}
            style={{ display: this.state.disabledCnlGTO ? 'none' : 'flex' }}
          >
            <DeleteIcon />
            Cancelar GTO
          </div>
        </div>

        {this.state.disabledCnlGTO ? "" : (
          <p className="descricao noselect">
            Para faturar a GTO, entre em cada procedimento para colocar a data e os anexos
            necessários.
            <br />
            Por fim, anexe a GTO assinada.
          </p>
        )}

        {this.state.isReloading && <ContainedLoader style={{ marginTop: 30 }} />}

        {!this.state.isReloading &&
          procedures.map(procedure => (
            <ExpansionPanel id="gtodetails-panel" key={procedure.cod_interno}>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                className="panel-header"
                disabled={procedure.flag_procedimento_excluido}
              >
                {loadingStatus ? (
                  <CircularProgress disableShrink style={{ width: 15, height: 15 }} />
                ) : (
                  this.verificarStatusProcedimento(procedure)

                )}

                <p className="card-label" style={{ marginTop: 6 }}>
                  <span className="txt-procedure">
                    {`${procedure.cod_proced} - ${procedure.procedimento}`}
                  </span>
                </p>
                {procedure.regiao !== '' && !Number.isNaN(procedure.regiao) && (
                  <p className="card-label">
                    <span>{`Dente: ${procedure.regiao}`}</span>
                  </p>
                )}
                {procedure.face !== '' && (
                  <p className="card-label">
                    <span>{`Face: ${procedure.face}`}</span>
                  </p>
                )}
                {procedure.regiao !== '' && Number.isNaN(procedure.regiao) && (
                  <p className="card-label">
                    <span>{`Região: ${procedure.regiao}`}</span>
                  </p>
                )}
                {procedure.descr_glosa_pre_faturamento !== '' && procedure.flag_pagamento_pre_faturamento !== true && (
                  <p className="card-label">
                    <span>{`Código TISS: ${procedure.cod_glosa_tiss_pre_faturamento} ${procedure.descr_glosa_pre_faturamento}`}</span>
                  </p>
                )}
                {procedure.emissao !== '' && (
                  <p className="card-label">
                    <span>{`Procedimento solicitado em: ${procedure.emissao}`}</span>
                  </p>
                )}
                {procedure.descr_glosa_amigavel_pre_faturamento !== '' && (
                  <p className="card-label" style={{ fontWeight: 600, color: '#212121' }}>
                    {procedure.descr_glosa_amigavel_pre_faturamento}
                  </p>
                )}
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className="procedure-panel-details" style={{ display: procedure.flag_procedimento_excluido == true ? "none" : "flex" }}>
                <Button
                  className="btn btn-excluir"
                  startIcon={<DeleteIcon />}
                  variant="outlined"
                  disableElevation
                  disabled={procedure.flag_procedimento_excluido}
                  onClick={() => this.handleExcluirGto(procedure)}
                >
                  Cancelar
                </Button>
                <Button
                  className="btn btn-editar"
                  startIcon={<ReceiptIcon />}
                  variant="outlined"
                  disableElevation
                  disabled={procedure.flag_procedimento_excluido}
                  onClick={() => this.handleFaturarProcedimento(procedure)}
                >
                  Faturar
                </Button>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}

        {this.state.disabledCnlGTO ? "" : (
          <div className="info-header noselect">
            <p>
              <span>GTO assinada</span>
            </p>
            <div className="attach-images__container">
              <li className="image">
                <div className="box-image">
                  <span>
                    <div className="attach">
                      <span className="upImage" />
                      <div className="btn-upLoad">
                        <input
                          className="upload-input"
                          onChange={event => this.handleAddImage(event)}
                          type="file"
                          accept={formatsInputFile}
                          key={this.state.inputFileKey}
                        />
                      </div>
                    </div>
                    <span className="nameImage">Anexar Arquivo</span>
                  </span>
                </div>
              </li>
              {imagesPending.map((item, index) => (
                <li className="image" key={index}>
                  <div className="box-image">
                    <span>
                      <div className="attach">
                        <div className={"box--thumbnail" + (item.name.includes('.pdf') ? '-pdf' : '')}>
                          <span
                            className="btn-close"
                            role="button"
                            tabIndex={0}
                            onClick={this.handleRemoveImgGTO}
                          />
                          <img crossorigin="anonymous" className="thumbnail" src={item.name.includes('.pdf') ? PdfIcon : item.src} alt="thumbnail" />
                        </div>
                      </div>
                      <span className="nameImage">{item.name}</span>
                    </span>
                  </div>
                </li>
              ))}
            </div>
          </div>
        )}

        {this.state.disabledCnlGTO ? "" : (
          <div className="info-header noselect">
            <p>
              <span>Observação</span>
            </p>
            <Row>
              <Input
                className="txt-observacao"
                type="textarea"
                label="Digite aqui sua observação (opcional)"
                onChange={this.handleObservacao}
                value={this.state.observacoes}
                maxLength="500"
                l={12}
                m={12}
                s={12}
                xl={12}
              />
            </Row>
          </div>
        )}

        {this.state.disabledCnlGTO ? "" : (
          <p className="warning-gto noselect">
            Os procedimentos sem data de realização serão automaticamente cancelados e não serão
            faturados.
          </p>
        )}

        {this.state.disabledCnlGTO ? "" : (
          <div className="btn-enviar">
            <Button
              variant="contained"
              disableElevation
              onClick={this.countProceduresPending}
              disabled={this.state.btnDisabled ? this.state.btnDisabled : btnDisable}
            >
              {this.state.btnDisabled ? (
                <CircularProgress disableShrink style={{ width: 20, height: 20, color: '#fff' }} />
              ) : (
                'Enviar faturamento'
              )}
            </Button>
          </div>
        )}

        {isLoadingFaturamento && <OverlaiedLoaderMsg />}

        <Dialog
          maxWidth="xs"
          open={alertCreatedGto}
          onClose={this.handleOkFaturar}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>GTO enviada para análise!</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText style={{ color: '#212121', fontSize: 15, textAlign: 'left', margin: 0 }}>
              {``}
              <>
                <u style={{ fontWeight: 'bold' }}>Protocolo de recebimento:</u><br />
                <span style={{ fontWeight: 'bold' }}>Nº da GTO: </span>
                <span>{gtoId}</span><br />
                <span style={{ fontWeight: 'bold' }}>Número da carteira do beneficiário: </span>
                <span>{this.state.procedures[0] == null ? '' : this.state.procedures[0].cod_benef}</span><br />
                <span style={{ fontWeight: 'bold' }}>Registro ANS: </span>
                <span>{this.state.regANS}</span><br />
                <span style={{ fontWeight: 'bold' }}>Data de envio da guia de cobrança: </span>
                <span>{new Date().toLocaleDateString() + ""}</span><br />
                <span style={{ fontWeight: 'bold' }}>Data de previsão de pagamento: </span>
                <span>{this.state.dataPagamento}</span><br />
                <span style={{ fontWeight: 'bold' }}>Valor total do protocolo: </span>
                <span> R${this.somarValorTotalProcedimentos()}</span><br />
              </>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              onClick={this.handleOkFaturar}
              color="inherit"
              style={{ width: '90%', fontSize: '1rem' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          open={alertCard}
          onClose={() => this.setState({ alertCard: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>{`Cancelar GTO ${gtoId}`}</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              Tem certeza que deseja cancelar essa GTO? Essa ação cancelará todos os
              procedimentos.
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={() => this.setState({ alertCard: false })}
              color="inherit"
            >
              NÃO
            </Button>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={this.handleOk}
              color="inherit"
            >
              SIM
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          open={alertCardProcedure}
          onClose={() => this.setState({ alertCardProcedure: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>Cancelar procedimento</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              <>
                Tem certeza que deseja cancelar o procedimento
                {' '}
                <strong>
                  {`${selectedProcedure.cod_proced ? selectedProcedure.cod_proced.trim() : ''} - ${selectedProcedure.procedimento
                    }`}
                </strong>
                {' '}
                ?
              </>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={() => this.setState({ alertCardProcedure: false })}
              color="inherit"
            >
              NÃO
            </Button>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={this.handleOk}
              color="inherit"
            >
              <strong>SIM</strong>
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          open={alertGtoPending}
          onClose={() => this.setState({ alertGtoPending: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center', color: '#1b365d' }}>
            <strong>{`${pendingCount} procedimento(s) sem data de realização`}</strong>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              Caso já tenha(m) sido realizado(s) clique em Datar procedimento, caso contrário, o(s)
              procedimento(s) sem data de realização será(ão)
              {' '}
              <strong>automaticamente cancelado(s) e não faturado(s)</strong>
              . Clique em Faturar
              mesmo assim para prosseguir com o faturamento.
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'space-around', color: '#dc6b2f' }}>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={this.handleFaturar}
              color="inherit"
            >
              Faturar mesmo assim
            </Button>
            <Button
              style={{ width: '40%', fontSize: '1rem' }}
              onClick={() => this.setState({ alertGtoPending: false })}
              color="inherit"
            >
              <strong>Datar procedimento</strong>
            </Button>
          </DialogActions>
        </Dialog>
      </ModalBox>
    );
  }
}

const mapStateToProps = ({ login }) => ({
  codigo: login.user.codigo
});

export default connect(mapStateToProps)(GtoDetails);